import { render, staticRenderFns } from "./InvoiceInvitations.vue?vue&type=template&id=21b8c9aa&"
import script from "./InvoiceInvitations.vue?vue&type=script&lang=js&"
export * from "./InvoiceInvitations.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInvitations.vue?vue&type=style&index=0&id=21b8c9aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports